import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'Resource Description Framework' ontology */
export const ns = createNS("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
/* Classes */
/** The datatype of RDF literals storing fragments of HTML content */
export const HTML = /*#__PURE__*/ ns("HTML");
/** The datatype of language-tagged string values */
export const langString = /*#__PURE__*/ ns("langString");
/** The class of plain (i.e. untyped) literal values, as used in RIF and OWL 2 */
export const PlainLiteral = /*#__PURE__*/ ns("PlainLiteral");
/** The class of RDF properties. */
export const Property = /*#__PURE__*/ ns("Property");
/** The class of RDF statements. */
export const Statement = /*#__PURE__*/ ns("Statement");
/** The class of unordered containers. */
export const Bag = /*#__PURE__*/ ns("Bag");
/** The class of ordered containers. */
export const Seq = /*#__PURE__*/ ns("Seq");
/** The class of containers of alternatives. */
export const Alt = /*#__PURE__*/ ns("Alt");
/** The class of RDF Lists. */
export const List = /*#__PURE__*/ ns("List");
/** The empty list, with no items in it. If the rest of a list is nil then the list has no more items in it. */
export const nil = /*#__PURE__*/ ns("nil");
/** The datatype of XML literal values. */
export const XMLLiteral = /*#__PURE__*/ ns("XMLLiteral");
/* Properties */
/** The subject is an instance of a class. */
export const type = /*#__PURE__*/ ns("type");
/** The subject of the subject RDF statement. */
export const subject = /*#__PURE__*/ ns("subject");
/** The predicate of the subject RDF statement. */
export const predicate = /*#__PURE__*/ ns("predicate");
/** The object of the subject RDF statement. */
export const object = /*#__PURE__*/ ns("object");
/** Idiomatic property used for structured values. */
export const value = /*#__PURE__*/ ns("value");
/** The first item in the subject RDF list. */
export const first = /*#__PURE__*/ ns("first");
/** The rest of the subject RDF list after the first item. */
export const rest = /*#__PURE__*/ ns("rest");
/* Other terms */
